import React from 'react';

const AboutBanner = () => {
  return (
    <>
     
      {/* Parallax Section */}
      <section 
        className="relative min-h-[600px] h-[75vh] flex items-center justify-center bg-fixed bg-cover bg-center px-4 md:px-8"
        style={{ 
          backgroundImage: `url('https://img.magnific.com/free-vector/gradient-blur-pink-blue-abstract-background_53876-117324.jpg?semt=ais_hybrid&w=740&q=80')` 
        }}
      >
        {/* Translucent Centered Card */}
        <div className="w-full max-w-4xl bg-white/75 backdrop-blur-md px-8 py-12 md:p-16 text-center md:text-left shadow-lg border border-white/20">
        <p className="text-xl md:text-3xl font-light text-cogCyan leading-relaxed tracking-wide font-sans">
  At PVS Harness Solutions, we believe strong partnerships begin with trust, collaboration, and technical excellence. By combining advanced engineering, precision manufacturing, and rigorous quality standards, we develop wiring harness solutions that meet the evolving needs of modern industries. Every project is approached with a focus on reliability, innovation, and continuous improvement, ensuring lasting value for our customers from concept through production.
</p>
        </div>
      </section>

    </>
  );
};

export default AboutBanner;